
import FilmographyHero from './components/FilmographyHero';
import FilmographyList from './components/FilmographyList';
import FilmographyFooter from './components/FilmographyFooter';

const FilmographyPage = () => {
  return (
    <main className="bg-black min-h-screen">
      <FilmographyHero />
      <FilmographyList />
      <FilmographyFooter />
    </main>
  );
};

export default FilmographyPage;
